module.exports = __webpack_public_path__ + "media/images/index-jumping-bg-99a09b8218511d191f9590f04b5a7b86.jpg";